/* Freezbone homepage v2 (Dan, Sep 26 2026) - behaviour for sections/fz-home-*.liquid.
   Plain JS, no dependencies, everything delegated from document (works after theme-editor section reloads).
   - Best Sellers / Bundle & Save tabs     - swipe-row dots + desktop arrows
   - "Shop best sellers" jump              - Quick shop sheet -> /cart/add.js (the HS Slide Cart opens itself on add)
   - videos: phone = tap-to-play in the card (one at a time, pauses when swiped away);
     desktop/tablet (>=750px) = pop-up player with prev/next (Dan, Sep 26 2026: native fullscreen blew the portrait clips up)
   UK/EU (Sep 27 2026): quick-shop wording and product text are read from hidden plain text in the shop section
   ([data-fzh-i18n], [data-fzh-txt]) so Weglot's page translation reaches them; kg / "FOR 10 - 40 KG DOGS" size names;
   prices follow the store's own money format (€48,33). US pages without those nodes behave exactly as before. */
(function () {
  if (window.fzHome) return;
  window.fzHome = true;
  var d = document;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- fade-in on scroll: only sections that start below the first screen, never in the theme editor ---------- */
  (function () {
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;
    function run() {
      var secs = $$('.fzh-sec, .fzh-gu-wrap').filter(function (el) { return el.id !== 'fzh-hero' && el.getBoundingClientRect().top > innerHeight; });
      if (!secs.length) return;
      var ob = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); ob.unobserve(x.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      secs.forEach(function (el) { el.classList.add('fzh-rv'); ob.observe(el); });
    }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
  })();

  /* ---------- tabs ---------- */
  function selectTab(btn) {
    var sec = btn.closest('.fzh-shop'); if (!sec) return;
    var n = btn.getAttribute('data-fzh-tab');
    $$('[data-fzh-tab]', sec).forEach(function (b) {
      var on = b === btn; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1;
    });
    $$('[data-fzh-panel]', sec).forEach(function (p) {
      var on = p.getAttribute('data-fzh-panel') === n; p.hidden = !on;
      if (on) { var r = $('[data-fzh-reel]', p); if (r) { r.scrollLeft = 0; dots(r); } }
    });
  }

  /* ---------- reels: dots + arrows ---------- */
  function dots(reel) {
    var box = reel.parentElement && reel.parentElement.querySelector(':scope > .fzh-dots'); if (!box) return;
    var kids = reel.children, mid = reel.scrollLeft + reel.clientWidth / 2, best = 0, bd = 1e9;
    if (reel.scrollLeft < 4) best = 0;
    else if (reel.scrollLeft + reel.clientWidth >= reel.scrollWidth - 4) best = kids.length - 1;
    else for (var i = 0; i < kids.length; i++) { var dd = Math.abs(kids[i].offsetLeft + kids[i].offsetWidth / 2 - mid); if (dd < bd) { bd = dd; best = i; } }
    $$('i', box).forEach(function (el, i) { el.classList.toggle('on', i === best); });
  }
  var ticking = false;
  d.addEventListener('scroll', function (e) {
    var r = e.target; if (!r || !r.hasAttribute) return;
    if (qs && r.hasAttribute('data-qv-main')) { if (Date.now() < (qs.jumpUntil || 0)) return; var k = Math.round(r.scrollLeft / Math.max(1, r.clientWidth)); if (k !== qs.img) markImg(k); return; }
    if (!r.hasAttribute('data-fzh-reel') || ticking) return;
    ticking = true; requestAnimationFrame(function () { ticking = false; dots(r); });
  }, { capture: true, passive: true });

  /* ---------- quick shop ---------- */
  var COLORS = { navy: '#1D2B6E', purple: '#6A2C8E', pink: '#F0A6BF', yellow: '#F2C230', blue: '#2B5BA8', green: '#3E8E5A', red: '#C8332B', orange: '#F74E00', black: '#1F1A17', white: '#FFFFFF', mint: '#98D8C1', teal: '#2A9D8F', grey: '#9A9A9A', gray: '#9A9A9A', brown: '#7A4A2A',
    /* Sep 30 2026: colours the stores use that were missing (they showed grey), picked from the product photos */
    coral: '#B5493B', 'light blue': '#3E68A8', lightblue: '#3E68A8', aqua: '#A9CFC6', cream: '#E9E1D4', silver: '#C9C3BD' };
  var qs = null, lastOpener = null;
  var T = { add: 'Add to cart', adding: 'Adding…', sold: 'Sold out', inside: 'What’s inside', full: 'View full details', reviews: 'reviews', save: 'Save 10%', colour: '', size: '', upto: 'Up to', forw: 'For', err: 'Something went wrong. Please try again.' };
  function loadT() { $$('[data-fzh-i18n] [data-k]').forEach(function (el) { var t = el.textContent.replace(/\s+/g, ' ').trim(); if (t) T[el.getAttribute('data-k')] = t; }); }
  function fmtCount(n) { var box = $('[data-fzh-i18n]'), sep = box && box.hasAttribute('data-sep') ? box.getAttribute('data-sep') : ','; return String(Math.round(+n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function isColor(name) { return /^colou?r$/i.test(name); }
  /* "S | UP TO 5 KG DOGS", "XXL |UP TO 65+ KG DOGS", "S - UP TO 27 KG DOGS" -> S + "Up to 5 kg";
     "FOR 10 - 40 KG DOGS" / "UP TO 64 KG DOGS" (no size letter) -> the weight becomes the button text; "L" alone stays "L" */
  function sizeParts(v) {
    var s = String(v).replace(/\s+/g, ' ').trim(), code = '', rest = s, m;
    m = s.match(/^(XXXL|XXL|XL|XS|S|M|L|SMALL|MEDIUM|LARGE)\s*(?:\||-|–|—)\s*(.+)$/i);
    if (m) { code = m[1]; rest = m[2]; }
    else if (/^(XXXL|XXL|XL|XS|S|M|L|SMALL|MEDIUM|LARGE)$/i.test(s)) { code = s; rest = ''; }
    else if (s.indexOf('|') > -1) { code = s.split('|')[0].trim(); rest = s.split('|').slice(1).join('|').trim(); }
    var w = rest.toLowerCase().replace(/\s*dogs?$/, '').replace(/(\d\+?)\s*[-–]\s*(\d)/g, '$1–$2');
    w = w.replace(/^up to\s+/, T.upto + ' ').replace(/^for\s+/, T.forw + ' ');
    if (w) w = w.charAt(0).toUpperCase() + w.slice(1);
    if (!code) { code = w; w = ''; }
    return { code: code, w: w };
  }
  function findVariant(sel, strictIdx) {
    var V = qs.data.variants, i, j, ok;
    for (i = 0; i < V.length; i++) { ok = true; for (j = 0; j < sel.length; j++) if (V[i].o[j] !== sel[j]) { ok = false; break; } if (ok) return V[i]; }
    for (i = 0; i < V.length; i++) if (V[i].o[strictIdx] === sel[strictIdx] && V[i].a) return V[i];
    for (i = 0; i < V.length; i++) if (V[i].o[strictIdx] === sel[strictIdx]) return V[i];
    return V[0];
  }
  function variantFor(optIdx, val) {
    var s = qs.sel.slice(); s[optIdx] = val;
    var V = qs.data.variants, i, j, ok;
    for (i = 0; i < V.length; i++) { ok = true; for (j = 0; j < s.length; j++) if (V[i].o[j] !== s[j]) { ok = false; break; } if (ok) return V[i]; }
    for (i = 0; i < V.length; i++) if (V[i].o[optIdx] === val) return V[i];
    return null;
  }
  function uniq(idx) { var out = []; qs.data.variants.forEach(function (v) { if (out.indexOf(v.o[idx]) < 0) out.push(v.o[idx]); }); return out; }
  function galleryHTML(D) {
    var ims = D.images && D.images.length ? D.images : [{ u: D.img, m: D.img, t: D.img, alt: D.title }];
    var h = '<div class="qv-gal"><div class="qv-stage"><div class="qv-main" data-qv-main>';
    ims.forEach(function (im, i) {
      h += '<figure><img src="' + esc(im.m) + '" srcset="' + esc(im.m) + ' 600w, ' + esc(im.u) + ' 900w" sizes="(min-width: 990px) 540px, 100vw" alt="' + esc(im.alt) + '" width="600" height="600"' + (i > 1 ? ' loading="lazy"' : '') + '></figure>';
    });
    h += '</div>';
    if (ims.length > 1) {
      h += '<button type="button" class="qv-nav prev" data-qv-go="-1" aria-label="Previous photo">‹</button><button type="button" class="qv-nav next" data-qv-go="1" aria-label="Next photo">›</button>';
      h += '<div class="qv-dots" aria-hidden="true">' + ims.map(function (x, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') + '</div>';
    }
    h += '</div>';
    if (ims.length > 1) h += '<div class="qv-thumbs">' + ims.map(function (im, i) { return '<button type="button" data-qv-img="' + i + '" aria-label="Photo ' + (i + 1) + ' of ' + ims.length + '" aria-current="' + (i === 0) + '"><img src="' + esc(im.t) + '" alt="" width="80" height="80" loading="lazy"></button>'; }).join('') + '</div>';
    return h + '</div>';
  }
  function markImg(i) {
    qs.img = i;
    $$('.qv-thumbs button', qs.sheet).forEach(function (b, k) { b.setAttribute('aria-current', String(k === i)); });
    $$('.qv-dots i', qs.sheet).forEach(function (b, k) { b.classList.toggle('on', k === i); });
    var tb = $$('.qv-thumbs button', qs.sheet)[i]; if (tb && tb.scrollIntoView) { var row = tb.parentElement; row.scrollLeft = Math.max(0, tb.offsetLeft - row.clientWidth / 2 + tb.offsetWidth / 2); }
  }
  function goImg(i, smooth) {
    var main = $('[data-qv-main]', qs.sheet); if (!main || !main.children.length) return;
    var n = main.children.length; i = ((i % n) + n) % n;
    var glide = smooth && !reduce && Math.abs(i - qs.img) === 1;   /* next/previous glides; longer jumps (e.g. picking a colour) are instant */
    qs.jumpUntil = glide ? Date.now() + 700 : 0;
    main.scrollTo({ left: i * main.clientWidth, behavior: glide ? 'smooth' : 'auto' });
    markImg(i);
  }
  function money(cents) {
    /* same format as the store's own price text (pf): "$40.72", "£40.72", "€40,72" */
    var pf = qs && qs.v && qs.v.pf, m = pf && pf.match(/\d[\d.,\s]*\d|\d/);
    if (m) {
      var dec = /,\d{2}$/.test(m[0]) ? ',' : '.', parts = (cents / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, dec === ',' ? '.' : ',');
      return pf.replace(m[0], /[.,]\d{2}$/.test(m[0]) ? parts.join(dec) : parts[0]);
    }
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function buyLabel() { var v = qs.v; if (!v.a) return T.sold; return T.add + ' · ' + (qs.qty > 1 ? money(v.p * qs.qty) : v.pf); }
  /* the offer running on the site, in one short strip under the price (Dan, Sep 30 2026, same look as the product page).
     World Animal Day (UK/EU, until Sun 4 Oct) = one line; after it, the Buy 2/3/4 boxes from the side cart's settings (FzCartConfig).
     The words come from the hidden [data-fzh-i18n] text (keys wad1 wad2 b2 b3 b4 s2 s3 s4), so Weglot translates them. */
  function promoHTML() {
    try {
      if (window.fzWad && window.fzWad.on) {
        /* Halloween Sale (Oct 20–31 2026): Everything 20% off + the two spend gifts, from the side cart's settings */
        var hc = JSON.parse((d.getElementById('FzCartConfig') || {}).textContent || '{}');
        if (hc.halloween && hc.spendGifts && hc.spendGifts.length === 2) {
          var hcells = ['<div><b>' + esc(T.hwe || 'Everything') + '</b><span>' + esc(T.hwp || '20% off') + '</span></div>'].concat(hc.spendGifts.map(function (x, i) { return '<div><b>' + money(x.amt).replace(/[.,]00(?=\D*$)/, '') + '+</b><span>' + esc(T['hwg' + (i + 1)] || ('Free ' + (x.label || x.name))) + '</span></div>'; }));
          return '<div class="qv-promo" style="grid-template-columns:repeat(3,minmax(0,1fr))">' + hcells.join('') + '</div>';
        }
      }
      if (window.fzWad && window.fzWad.on) return '<div class="qv-promo qv-promo--one"><div><b>' + esc(T.wad1 || '20% off everything') + '</b><span>' + esc(T.wad2 || 'World Animal Day · taken off automatically') + '</span></div></div>';
      var c = JSON.parse((d.getElementById('FzCartConfig') || {}).textContent || '{}'), t = c.tiers || [];
      var cells = t.map(function (x, k) {
        var b = T['b' + x.qty] || ('Buy ' + x.qty + (k === t.length - 1 ? '+' : '')), s = T['s' + x.qty];
        if (!s || s.indexOf(String(x.pct)) < 0) s = 'Save ' + x.pct + '%';
        return '<div><b>' + esc(b) + '</b><span>' + esc(s) + '</span></div>';
      });
      return cells.length ? '<div class="qv-promo" style="grid-template-columns:repeat(' + cells.length + ',minmax(0,1fr))">' + cells.join('') + '</div>' : '';
    } catch (e) { return ''; }
  }
  function bodyHTML() {
    var D = qs.data, v = qs.v, h = [];
    if (D.count) h.push('<div class="qv-rate"><span class="fzh-st" aria-hidden="true">★★★★★</span><b>' + esc(isNaN(parseFloat(D.rating)) ? D.rating : parseFloat(D.rating).toFixed(1)) + '</b><span>' + fmtCount(D.count) + ' ' + esc(T.reviews) + '</span></div>');
    h.push('<h2 class="qv-title" id="fzh-qs-title">' + esc(D.title) + '</h2>');
    if (D.summary) h.push('<p class="qv-sum">' + esc(D.summary) + '</p>');
    var badge = D.badge && !/review|rated|stars?\b/i.test(D.badge) ? D.badge : ''; /* skip badges that only repeat the star rating shown above */
    if (badge || D.chew) h.push('<div class="qv-chips">' + (badge ? '<span class="qv-chip">' + esc(badge) + '</span>' : '') + (D.chew ? '<span class="qv-chip o">For ' + esc(String(D.chew).toLowerCase()) + '</span>' : '') + '</div>');
    var save = v.c > v.p ? Math.round((v.c - v.p) / v.c * 100) : 0;
    h.push('<div class="qv-price"><b>' + esc(v.pf) + '</b>' + (v.cf ? '<s><span class="visually-hidden">Regular price </span>' + esc(v.cf) + '</s>' : '') + (save >= 5 && window.fzWad && window.fzWad.on ? '<em class="hw-pct">\u2212' + save + '%</em>' : '') + (save >= 5 && !(window.fzWad && window.fzWad.on) ? '<span class="qv-save">' + esc(/\d+/.test(T.save) ? T.save.replace(/\d+/, save) : T.save + ' ' + save + '%') + '</span>' : '') + '</div>');
    h.push(promoHTML());
    D.options.forEach(function (name, idx) {
      var vals = uniq(idx);
      if (vals.length === 1 && /^default title$/i.test(vals[0])) return;
      if (isColor(name)) {
        var cl = T.colour || name;
        h.push('<p class="lab">' + esc(cl) + ': <small>' + esc(qs.sel[idx]) + '</small></p><div class="cols" role="group" aria-label="' + esc(cl) + '">');
        vals.forEach(function (val) {
          var vv = variantFor(idx, val), hex = COLORS[String(val).toLowerCase()] || '#CCCCCC';
          h.push('<button type="button" data-opt="' + idx + '" data-val="' + esc(val) + '" aria-pressed="' + (qs.sel[idx] === val) + '" aria-label="' + esc(val) + (vv && !vv.a ? ' (sold out)' : '') + '" title="' + esc(val) + '" class="' + (vv && !vv.a ? 'na' : '') + '" style="background:' + hex + '"></button>');
        });
        h.push('</div>');
      } else {
        var isSize = /^size$/i.test(name), cur = isSize ? sizeParts(qs.sel[idx]) : null;
        var nl = isSize && T.size ? T.size : name.charAt(0).toUpperCase() + name.slice(1);
        h.push('<p class="lab">' + esc(nl) + (isSize ? ': <small>' + esc(cur.code + (cur.w ? ' · ' + cur.w : '')) + '</small>' : '') + '</p><div class="sizes' + (vals.length === 1 ? ' one' : '') + '" role="group" aria-label="' + esc(nl) + '">');
        vals.forEach(function (val) {
          var vv = variantFor(idx, val), sp = isSize ? sizeParts(val) : { code: val, w: '' };
          var sub = [sp.w, vv ? vv.pf : ''].filter(Boolean).join(' · ') + (vv && !vv.a ? ' · ' + T.sold : '');
          h.push('<button type="button" data-opt="' + idx + '" data-val="' + esc(val) + '" aria-pressed="' + (qs.sel[idx] === val) + '" class="' + (vv && !vv.a ? 'na' : '') + '"><b>' + esc(sp.code) + '</b><span>' + esc(sub) + '</span></button>');
        });
        h.push('</div>');
      }
    });
    /* up to 3 short bullets set per product in the theme editor ("Quick shop bullets"); nothing when empty (Dan, Sep 27) */
    var pts = (D.points || []).map(function (x) { return String(x).trim(); }).filter(Boolean).slice(0, 3);
    if (pts.length) h.push('<div class="qv-det"><p class="lab">' + esc(T.inside) + '</p><ul>' + pts.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>');
    h.push('<a class="qv-full" href="' + esc(D.url) + '?variant=' + v.id + '">' + esc(T.full) + ' <span aria-hidden="true">→</span></a>');
    return h.join('');
  }
  function drawBody() {
    $('[data-qv-body]', qs.sheet).innerHTML = bodyHTML();
    var go = $('[data-fzh-add]', qs.sheet); go.disabled = !qs.v.a; go.textContent = buyLabel();
    $('[data-qv-n]', qs.sheet).textContent = qs.qty;
  }
  function draw() {
    qs.sheet.innerHTML = '<button type="button" class="x" data-fzh-close aria-label="Close">✕</button>' +
      '<div class="qv-scroll">' + galleryHTML(qs.data) + '<div class="qv-body" data-qv-body></div></div>' +
      '<div class="qv-buy"><div class="qv-qty" role="group" aria-label="Quantity"><button type="button" data-qv-qty="-1" aria-label="One less">−</button><span data-qv-n aria-live="polite">1</span><button type="button" data-qv-qty="1" aria-label="One more">+</button></div>' +
      '<button type="button" class="go" data-fzh-add></button></div><p class="err" role="alert" hidden></p>';
    drawBody();
  }
  function showVariantImage() {
    var v = qs.v, D = qs.data; if (!v.iid || !D.images) return;
    for (var i = 0; i < D.images.length; i++) if (D.images[i].id === v.iid) { goImg(i, true); return; }
  }
  function openQS(handle, opener) {
    var src = $('script[data-fzh-product="' + handle + '"]'), root = $('#fzh-qs'); if (!src || !root) return false;
    var data; try { data = JSON.parse(src.textContent); } catch (e) { return false; }
    loadT();
    var tx = $('[data-fzh-txt="' + handle + '"]');   /* translated copies of the product text, when present */
    if (tx) {
      var f = function (k) { var el = $('[data-f="' + k + '"]', tx); return el ? el.textContent.replace(/\s+/g, ' ').trim() : null; };
      ['title', 'summary', 'badge', 'chew'].forEach(function (k) { var t = f(k); if (t) data[k] = t; });
      var pts = $$('[data-f="pt"]', tx).map(function (el) { return el.textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
      if (pts.length) data.points = pts;
    }
    var first = data.variants.filter(function (v) { return v.id === data.first; })[0] || data.variants[0];
    qs = { data: data, v: first, sel: first.o.slice(), root: root, sheet: $('.fzh-qs-sheet', root), qty: 1, img: 0 };
    lastOpener = opener || null;
    /* on top of cookie bars that use the maximum z-index too (EU Avada bar covered "Add to bag"): same z-index, so be last in <body> */
    if (root.parentNode !== d.body || root.nextElementSibling) { $$('body > #fzh-qs').forEach(function (x) { if (x !== root) x.remove(); }); d.body.appendChild(root); }
    draw();
    root.hidden = false; d.body.classList.add('fzh-lock');
    /* Oct 28 2026 (Dan): always open on the first photo; picking a colour still jumps to that colour's photo */
    setTimeout(function () { qs && qs.sheet.focus(); }, 30);
    return true;
  }
  function closeQS() {
    if (!qs) return;
    qs.root.hidden = true; d.body.classList.remove('fzh-lock'); qs.sheet.innerHTML = ''; qs = null;
    if (lastOpener && lastOpener.focus) lastOpener.focus({ preventScroll: true });
  }
  function openCart() {
    try { if (window.Hs_CartDrawer && typeof Hs_CartDrawer.openCart === 'function') { Hs_CartDrawer.openCart(); return; } } catch (e) {}
    var t = $('.hs-open-cart-drawer') || $('#cart-icon-bubble') || $('header a[href$="/cart"]');
    if (t) t.click(); else location.href = '/cart';
  }
  function addToCart(btn) {
    var v = qs.v, D = qs.data, qty = qs.qty, err = $('.err', qs.sheet);
    if (!v.a || btn.classList.contains('busy')) return;
    btn.classList.add('busy'); btn.textContent = T.adding; err.hidden = true;
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qs.qty }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      try {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });
        dataLayer.push({ event: 'add_to_cart', source: 'homepage_quick_shop', ecommerce: { currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', value: v.p * qty / 100, items: [{ item_id: String(D.pid), item_variant: String(v.id), item_name: D.title, item_variant_name: v.o.join(' / '), price: v.p / 100, quantity: qty }] } });
      } catch (e) {}
      closeQS();
      /* the HS Slide Cart opens by itself on /cart/add; open it ourselves only if it hasn't within 1.2s */
      setTimeout(function () { if (!d.body.classList.contains('hs-open-cart')) openCart(); }, 1200);
    }).catch(function (e) {
      if (!qs) return;
      btn.classList.remove('busy'); btn.textContent = buyLabel();
      err.textContent = (e && (e.description || e.message)) || T.err; err.hidden = false;
    });
  }
  d.addEventListener('keydown', function (e) {
    if (vm && vm.open) {
      if (e.key === 'Escape') { vmClose(); return; }
      if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !(e.target && e.target.tagName === 'VIDEO')) { e.preventDefault(); vmShow(vm.i + (e.key === 'ArrowRight' ? 1 : -1)); return; }
      if (e.key === 'Tab') {
        var fv = $$('button:not([hidden]), video', vm.el), fa = fv[0], fz = fv[fv.length - 1];
        if (e.shiftKey && d.activeElement === fa) { e.preventDefault(); fz.focus(); }
        else if (!e.shiftKey && d.activeElement === fz) { e.preventDefault(); fa.focus(); }
      }
      return;
    }
    if (qs && e.key === 'Escape') { closeQS(); return; }
    if (qs && (e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !(e.target && /INPUT|SELECT|TEXTAREA/.test(e.target.tagName))) { e.preventDefault(); goImg(qs.img + (e.key === 'ArrowRight' ? 1 : -1), true); return; }
    if (qs && e.key === 'Tab') {
      var f = $$('button:not([disabled]), a[href]', qs.sheet); if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && (d.activeElement === a || d.activeElement === qs.sheet)) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); }
      return;
    }
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-fzh-tab') && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      var tabs = $$('[data-fzh-tab]', t.closest('[role="tablist"]')), i = tabs.indexOf(t);
      var nx = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; nx.focus(); selectTab(nx);
    }
  });

  /* ---------- videos ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.intersectionRatio < 0.35 && !x.target.paused) x.target.pause(); });
  }, { threshold: [0, 0.35] }) : null;
  function playVideo(btn) {
    var frame = btn.parentElement, img = $('img', btn), v = d.createElement('video');
    var hls = btn.getAttribute('data-hls'), mp4 = btn.getAttribute('data-mp4');
    v.controls = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.preload = 'auto';
    if (img) v.poster = img.currentSrc || img.src;
    v.src = hls && v.canPlayType('application/vnd.apple.mpegurl') ? hls : (mp4 || hls);
    v.setAttribute('aria-label', btn.getAttribute('aria-label').replace(/^Play video: /, ''));
    v.addEventListener('play', function () { $$('.fzh-vframe video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); }); });
    frame.appendChild(v); btn.hidden = true;
    if (io) io.observe(v);
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }

  /* desktop pop-up player */
  var wide = window.matchMedia ? matchMedia('(min-width: 750px)') : { matches: false };
  var vm = null;
  function srcFor(btn, v) { var hls = btn.getAttribute('data-hls'), mp4 = btn.getAttribute('data-mp4'); return hls && v.canPlayType('application/vnd.apple.mpegurl') ? hls : (mp4 || hls); }
  function bigPoster(img) { if (!img) return ''; var ss = (img.getAttribute('srcset') || '').split(',').pop().trim().split(' ')[0]; return ss || img.currentSrc || img.src; }
  function vmShow(i) {
    var n = vm.list.length; vm.i = (i + n) % n;
    var btn = vm.list[vm.i], frame = $('.fzh-vm-frame', vm.el), old = $('video', frame);
    if (old) { old.pause(); old.removeAttribute('src'); old.load(); old.remove(); }
    var v = d.createElement('video');
    v.controls = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'auto';
    v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback'); v.disablePictureInPicture = true;
    v.poster = bigPoster($('img', btn)); v.src = srcFor(btn, v);
    var cap = $('.fzh-cap b', btn), title = cap ? cap.textContent.trim() : btn.getAttribute('aria-label').replace(/^Play video: /, ''), dur = $('.fzh-cap span', btn);
    v.setAttribute('aria-label', title);
    frame.appendChild(v);
    $('figcaption', vm.el).innerHTML = '<b>' + esc(title) + '</b>' + (dur ? '<span>' + esc(dur.textContent) + '</span>' : '');
    $$('.fzh-vm-nav', vm.el).forEach(function (b) { b.hidden = n < 2; });
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function vmOpen(btn) {
    if (!vm) {
      var el = d.createElement('div');
      el.className = 'fzh fzh-vm'; el.hidden = true;
      el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', 'Customer video');
      el.innerHTML = '<div class="fzh-vm-bd" data-fzh-vm-close></div>' +
        '<button type="button" class="fzh-vm-x" data-fzh-vm-close aria-label="Close video">✕</button>' +
        '<button type="button" class="fzh-vm-nav" data-fzh-vm-go="-1" aria-label="Previous video">←</button>' +
        '<figure class="fzh-vm-box"><div class="fzh-vm-frame"></div><figcaption></figcaption></figure>' +
        '<button type="button" class="fzh-vm-nav" data-fzh-vm-go="1" aria-label="Next video">→</button>';
      d.body.appendChild(el); vm = { el: el };
    }
    $$('.fzh-vframe video').forEach(function (o) { o.pause(); });
    if (vm.el.nextElementSibling) d.body.appendChild(vm.el);
    var reel = btn.closest('[data-fzh-reel]');
    vm.list = reel ? $$('[data-fzh-video]', reel) : [btn];
    vm.opener = btn; vm.open = true;
    vm.el.hidden = false; d.body.classList.add('fzh-lock');
    vmShow(Math.max(0, vm.list.indexOf(btn)));
    setTimeout(function () { var x = $('.fzh-vm-x', vm.el); if (x) x.focus(); }, 30);
  }
  function vmClose() {
    if (!vm || !vm.open) return;
    var v = $('.fzh-vm-frame video', vm.el);
    if (v) { v.pause(); v.removeAttribute('src'); v.load(); v.remove(); }
    vm.el.hidden = true; vm.open = false; d.body.classList.remove('fzh-lock');
    if (vm.opener && vm.opener.focus) vm.opener.focus({ preventScroll: true });
  }

  /* ---------- clicks ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target, el;
    if (vm && vm.open) {
      if (t === vm.el || t.closest('[data-fzh-vm-close]')) { vmClose(); return; }
      el = t.closest('[data-fzh-vm-go]'); if (el) { vmShow(vm.i + +el.getAttribute('data-fzh-vm-go')); return; }
      return;
    }
    if (qs) {
      if (t.closest('[data-fzh-close]')) { closeQS(); return; }
      el = t.closest('[data-qv-go]'); if (el) { goImg(qs.img + +el.getAttribute('data-qv-go'), true); return; }
      el = t.closest('[data-qv-img]'); if (el) { goImg(+el.getAttribute('data-qv-img'), true); return; }
      el = t.closest('[data-qv-qty]'); if (el) { qs.qty = Math.max(1, Math.min(10, qs.qty + +el.getAttribute('data-qv-qty'))); drawBody(); return; }
      el = t.closest('[data-opt]');
      if (el && qs.sheet.contains(el)) {
        var idx = +el.getAttribute('data-opt'); qs.sel[idx] = el.getAttribute('data-val');
        qs.v = findVariant(qs.sel, idx); qs.sel = qs.v.o.slice(); drawBody(); showVariantImage();
        var again = $('[data-opt="' + idx + '"][data-val="' + (window.CSS && CSS.escape ? CSS.escape(qs.sel[idx]) : qs.sel[idx]) + '"]', qs.sheet); if (again) again.focus();
        return;
      }
      el = t.closest('[data-fzh-add]'); if (el) { addToCart(el); return; }
      return;
    }
    el = t.closest('[data-fzh-tab]'); if (el) { selectTab(el); return; }
    el = t.closest('[data-fzh-qs]'); if (el) { if (openQS(el.getAttribute('data-fzh-qs'), el)) e.preventDefault(); return; }
    el = t.closest('[data-fzh-video]'); if (el) { e.preventDefault(); if (wide.matches) vmOpen(el); else playVideo(el); return; }
    el = t.closest('[data-fzh-scroll]');
    if (el) {
      var reel = $('[data-fzh-reel]', el.closest('.fzh')); if (!reel) return;
      reel.scrollBy({ left: +el.getAttribute('data-fzh-scroll') * Math.max(200, reel.clientWidth * 0.9), behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    el = t.closest('[data-fzh-jump]');
    if (el) {
      var href = el.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var target = d.getElementById(href.slice(1)); if (!target) return;
      e.preventDefault();
      var best = $('[data-fzh-tab="1"]', target); if (best && best.getAttribute('aria-selected') !== 'true') selectTab(best);
      /* land just below what stays pinned: the sticky header always; the promo bars too when scrolling UP
         (announcement-bar.liquid slides them back in on scroll-up) */
      var aim = $('.fzh-h2', target) || target;
      var top = aim.getBoundingClientRect().top, hdr = $('sticky-header') || $('.section-header'), bars = $('.fz-topbars');
      var off = 20 + (hdr ? hdr.offsetHeight : 0) + (top < 0 && bars ? bars.offsetHeight : 0);
      window.scrollTo({ top: Math.max(0, top + window.pageYOffset - off), behavior: reduce ? 'auto' : 'smooth' });
    }
  });
})();
